//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	data(){
		return{
			logReg:false,
			nickname:null,
			savePage:false
		}
	},
	computed: {
		direction() {
			return this.$store.state.direction;
		},
		sildeShow(){
			return this.$store.state.sildeShow;
		}
	},
	mounted(){
		this.$store.state.sildeShow = false;
	},
	methods: {
		changeDirection() {
			this.$store.state.direction = "left";
			//console.log(this.$store.state.direction)
			this.$store.state.sildeShow = false;
		},
		clearCookie(){
			this.logReg = false;
			com.setCookie('tel','');
		}
	},
	mounted(){
		var cookie = com.getCookie('tel');
		console.log(com.getCookie('tel'));
		if(cookie.length >0){
			this.logReg = true;
		}else{
			this.logReg = false;
		}
		this.nickname = com.getCookie('tel');
	}

}



// WEBPACK FOOTER //
// ./src/components/xsilde.vue